export default "__VITE_ASSET__CaGCq73w__"